export type { Portal, PortalState, ReqGroupsState, ReqTypesState, AnalyticAttributes } from './reducer';
export { default as portalReducer } from './reducer';
